import utils from '@/utils/utils'

const routerPath = [
  "/preheat",
  "/prehhh",
  "/prrheat",
  "/prehead",
  "/prehttt",
  "/preheee",
  "/prehddd",
  "/preheatone",
  "/preheattwo",
  "/preheatthree",
  "/preheatfour",
  "/preheatfive",
  "/preheatsix",
  "/preheatseven",
  "/preheateight",
  "/preheatnine",
  "/preheatten",
  "/preheateleven",
  "/preheattwelve",
  "/preheatthirteen",
  "/preheatfourteen",
  "/preheatfifteen",
  "/preheatsixteen",
  "/preheatseventeen",
  "/preheateighteen",
  "/preheatnineteen",
  "/preheattwenty",
  "/preheattwentyone",
  "/preheattwentytwo",
  "/preheattwentythree",
  "/preheatbase",
  "/preheata",
  "/preheatb",
  "/preheatc",
  "/preheatd",
  "/preheate",
  "/preheatf",
  "/preheatg",
  "/preheath",
  "/preheati",
  "/preheatj",
  "/preheatk",
]
const component = () => import('../pages/home/preheat.vue')

const routerList = routerPath.map((path) => {
  return utils.createRouterItem({
    path,
    meta: {
      title: '首页',
      showBottom: true
    },
    component,
  })
})
export default routerList
